import { Link } from 'react-router-dom';

/**
 * "Contact" — how to reach BestAcco. Original copy with the real entity details
 * and a few clearly-routed ways to get in touch (guests, hoteliers, press,
 * general). No form yet — straightforward contact channels.
 */
export default function ContactPage() {
  return (
    <div className="bg-cream text-ink">
      <section className="mx-auto max-w-4xl px-6 py-20 text-center sm:py-28">
        <p className="font-semibold uppercase tracking-[0.2em] text-clay">
          Contact
        </p>
        <h1 className="mt-4 font-serif text-4xl font-semibold leading-tight sm:text-5xl">
          Get in touch
        </h1>
        <p className="mx-auto mt-6 max-w-2xl text-lg leading-relaxed text-ink/70">
          We are a small team and we read everything. Whether you are planning a
          stay, run a hotel, or are writing about us, here is the quickest way to
          reach the right place.
        </p>
      </section>

      <section className="mx-auto max-w-5xl px-6 pb-16">
        <div className="grid gap-6 sm:grid-cols-2">
          <div className="rounded-xl border border-ink/10 bg-white p-7">
            <h2 className="font-serif text-xl font-semibold text-ink">
              Guest support
            </h2>
            <p className="mt-3 text-ink/70">
              Questions about a booking, a change of plans, or finding the right
              stay. Have your booking reference handy if you have one.
            </p>
            <a
              href="mailto:prateek.juneja@bestacco.com?subject=Guest%20support"
              className="mt-4 inline-block font-semibold text-clay underline"
            >
              prateek.juneja@bestacco.com
            </a>
          </div>

          <div className="rounded-xl border border-ink/10 bg-white p-7">
            <h2 className="font-serif text-xl font-semibold text-ink">
              Hoteliers &amp; partnerships
            </h2>
            <p className="mt-3 text-ink/70">
              Want your property on BestAcco, or exploring a partnership? Tell us
              about your hotel and we will take it from there.
            </p>
            <Link
              to="/list-your-property"
              className="mt-4 inline-block font-semibold text-clay underline"
            >
              List your hotel
            </Link>
          </div>

          <div className="rounded-xl border border-ink/10 bg-white p-7">
            <h2 className="font-serif text-xl font-semibold text-ink">Press</h2>
            <p className="mt-3 text-ink/70">
              Media inquiries, interviews, and brand assets. We respond to
              journalists promptly.
            </p>
            <a
              href="mailto:prateek.juneja@bestacco.com?subject=Press%20inquiry"
              className="mt-4 inline-block font-semibold text-clay underline"
            >
              prateek.juneja@bestacco.com
            </a>
          </div>

          <div className="rounded-xl border border-ink/10 bg-white p-7">
            <h2 className="font-serif text-xl font-semibold text-ink">
              Everything else
            </h2>
            <p className="mt-3 text-ink/70">
              General questions, feedback, or anything that does not fit a box
              above. We would love to hear it.
            </p>
            <a
              href="mailto:prateek.juneja@bestacco.com"
              className="mt-4 inline-block font-semibold text-clay underline"
            >
              prateek.juneja@bestacco.com
            </a>
          </div>
        </div>
      </section>

      {/* Company details */}
      <section className="mx-auto max-w-5xl px-6 pb-24">
        <div className="rounded-xl bg-ink px-7 py-8 text-cream/80">
          <h2 className="font-serif text-xl font-semibold text-cream">
            BestAcco LLC
          </h2>
          <p className="mt-3 leading-relaxed">
            Attn: Prateek Juneja
            <br />
            99 Free Henry Ford Road
            <br />
            Madisonville, KY 42431
            <br />
            United States
          </p>
          <p className="mt-4">
            <a
              href="mailto:prateek.juneja@bestacco.com"
              className="text-clay underline"
            >
              prateek.juneja@bestacco.com
            </a>
          </p>
        </div>
      </section>
    </div>
  );
}
